import { THEME } from './theme'
import type { EnemyVisualDefinition } from './types'

export const ENEMY_VISUALS: Record<string, EnemyVisualDefinition> = {
  normal: {
    id: 'normal',
    definitionId: 'normal',
    fill: THEME.normalEnemy,
    stroke: THEME.white,
    silhouette: 'circle',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  fast: {
    id: 'fast',
    definitionId: 'fast',
    fill: THEME.fastEnemy,
    stroke: THEME.white,
    silhouette: 'triangle',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  tank: {
    id: 'tank',
    definitionId: 'tank',
    fill: THEME.tankEnemy,
    stroke: THEME.white,
    silhouette: 'square',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  regen: {
    id: 'regen',
    definitionId: 'regen',
    fill: THEME.regenEnemy,
    stroke: THEME.white,
    silhouette: 'diamond',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  shield: {
    id: 'shield',
    definitionId: 'shield',
    fill: THEME.shieldEnemy,
    stroke: THEME.shield,
    silhouette: 'hexagon',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  boss: {
    id: 'boss',
    definitionId: 'boss',
    fill: THEME.bossEnemy,
    stroke: THEME.selection,
    silhouette: 'boss',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  flyer: {
    id: 'flyer',
    definitionId: 'flyer',
    fill: THEME.flyerEnemy,
    stroke: THEME.white,
    silhouette: 'flyer',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  air_boss: {
    id: 'air_boss',
    definitionId: 'air_boss',
    fill: THEME.airBossEnemy,
    stroke: THEME.selection,
    silhouette: 'air_boss',
    visualRadiusScale: 1.05,
    kind: 'procedural'
  },
  guardian: {
    id: 'guardian',
    definitionId: 'guardian',
    fill: THEME.guardianEnemy,
    stroke: THEME.white,
    silhouette: 'guardian',
    visualRadiusScale: 1.05,
    kind: 'procedural'
  },
  phase: {
    id: 'phase',
    definitionId: 'phase',
    fill: THEME.phaseEnemy,
    stroke: THEME.white,
    silhouette: 'phase',
    visualRadiusScale: 1,
    kind: 'procedural'
  },
  crystal: {
    id: 'crystal',
    definitionId: 'crystal',
    fill: THEME.crystalEnemy,
    stroke: THEME.white,
    silhouette: 'gem',
    visualRadiusScale: 1,
    kind: 'procedural'
  }
}

export const FALLBACK_ENEMY_VISUAL: EnemyVisualDefinition = {
  id: 'fallback-enemy',
  definitionId: 'fallback',
  fill: THEME.danger,
  stroke: THEME.white,
  silhouette: 'fallback',
  visualRadiusScale: 1,
  kind: 'procedural'
}
